export const TONE_SURFACES = {
  accent: 'bg-vantis-violet text-white',
  success: 'bg-success text-white',
  warning: 'bg-vantis-orange text-foreground',
  error: 'bg-vantis-red-muted text-foreground',
} as const;
